import React from 'react';

import { action } from 'mobx';

export const useAction = function <T extends Function>(callback: T, deps: React.DependencyList): T {
  return React.useCallback(action(callback), deps);
};

export const useNamedAction = function <T extends Function>(
  callback: T,
  deps: React.DependencyList,
  name: string
): T {
  return React.useCallback(action(name, callback), deps);
};
